import {call, put, select} from "redux-saga/effects";
import {setAddress, setCitiesAndAreas, setProvinces, updateAddress} from "../../slices/addressSlice";
import {getAreasByCity, getCitiesByProvince, getProvinces, postAddress} from "../requests/locationService";
import {setAppLoading} from "../../slices/authTokenSlice";
import {toast} from "react-toastify";


export function* handleGetProvinces() {
  try {
    yield put(setProvinces({loading: true}))
    const {data: provinces} = yield call(() => getProvinces(false))
    yield put(setProvinces({provinces}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setProvinces({error: errMsg}))
  }
}

export function* handleGetCitiesAndAreas(action) {
  const {parentId, type} = action.payload
  try {
    yield put(setCitiesAndAreas({loading: true, element: type, id: parentId}))
    const {data} = type === "cities" ?
      yield call(() => getCitiesByProvince(parentId, false)) :
      yield call(() => getAreasByCity(parentId, false))
    yield put(setCitiesAndAreas({element: type, id: parentId, data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setCitiesAndAreas({element: type, id: parentId, error: errMsg}))
  }
}

export function* handleAddAddress(action){
  const {isDefault, label, landmark, province, city, area, alternateNumber, customerId} = action.payload

  try{
    yield put(setAppLoading(true));
    const addressPayload = {
      default_address: isDefault,
      title: label,
      landmark: landmark,
      province: province.id,
      city: city.id,
      area: area.id,
      ...(alternateNumber && ({alternative_contact_number: alternateNumber}))
    }
    const {data } = yield call(() => postAddress(addressPayload, customerId));
    yield put(setAddress(data))
  }catch (error){
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  }finally {
    yield put(setAppLoading(false))
  }
}